import { useEffect, useState } from 'react';

import { getInstallBases } from 'services/basesServices';
import type { InstallBaseData } from 'services/basesServices';
import type { BaseFlags } from 'services/baseTerritoryService';
import {
  getBaseIrregularityReasons,
  isIrregularBase,
} from 'utils/blockReasons';

import type { IrregularBase } from './modals/IrregularBasesModal';

export const useIrregularBases = (
  flagsByBase: Record<string, BaseFlags>
): { bases: IrregularBase[]; isLoading: boolean } => {
  const [bases, setBases] = useState<InstallBaseData[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const load = async (): Promise<void> => {
      const response = await getInstallBases({ includeInactive: true });
      if (!active) return;
      setBases((response as InstallBaseData[]) ?? []);
      setIsLoading(false);
    };

    load();

    return () => {
      active = false;
    };
  }, []);

  return {
    isLoading,
    bases: bases
      .filter((base) => isIrregularBase(flagsByBase[base.name]))
      .map((base) => ({
        code: base.name,
        nickname: base.nickname || base.name,
        address: [base.address, base.number, base.complement]
          .filter(Boolean)
          .join(', '),
        reasons: getBaseIrregularityReasons(flagsByBase[base.name]),
      })),
  };
};

export default useIrregularBases;
